import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DealerProfile } from '@app/domain/model/dealer-profile';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './dealer-report-log.component.html',
  styleUrls: ['./dealer-report-log.component.scss']
})
export class DealerReportLogComponent implements OnInit, OnDestroy {

  profile: DealerProfile;
  private routeSubscription: Subscription;

  constructor(
    private route: ActivatedRoute, private readonly router: Router
  ) {
  }


  ngOnInit() {
    this.routeSubscription = this.route.data.subscribe(({ profile }) => {
      this.profile = profile;
      if(this.profile.bulkDataReport) {
        this.router.navigate([`/dealer/report-search`]);
      }
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

}

